module.exports = __webpack_public_path__ + "static/media/gabrielle_french_canadian.35d8b246.mp3";